import { Boss } from './enemies/boss.js';
import { circleVsAabb } from '../engine/collision.js';

export function spawnSummonedEnemy(game, type, opts = {}) {
  if (!game.room) return null;
  const sourceEnemy = opts.sourceEnemy ?? null;
  const originX = sourceEnemy?.x ?? opts.x ?? game.player?.x ?? 0;
  const originZ = sourceEnemy?.z ?? opts.z ?? game.player?.z ?? 0;
  const spawnAt = game._findSafeSummonSpawn(type, originX, originZ, {
    attempts: opts.attempts,
    minRadius: opts.minRadius,
    maxRadius: opts.maxRadius,
    minPlayerDistance: opts.minPlayerDistance,
    ignoreEnemy: sourceEnemy,
  });
  if (!spawnAt) return null;
  const enemy = game._addEnemyByType(type, spawnAt.x, spawnAt.z);
  if (!enemy) return null;
  if (game.player?.alive) {
    enemy.notifyPlayerDetected?.(game.player.x, game.player.z, 2.6);
  }
  return enemy;
}

export function spawnBossPhase(game, phase, x, z) {
  const boss = new Boss({
    scene: game.scene,
    x,
    z,
    audio: game.audio,
    fbx: phase === 2 ? game._boss02Fbx : game._boss01Fbx,
    phase,
  });
  game.enemies.push(boss);
  game.audio.playMusic('combat');
  const visualLabel = boss.usingFbxVisual ? 'FBX' : 'PROC';
  game.toast(phase === 2 ? `SPAWNED FINAL BOSS (${visualLabel})` : `SPAWNED MINI-BOSS (${visualLabel})`);
}

export function debugSpawnPoint(game, distance = 8.5) {
  const dx = game.input.mouse.worldX - game.player.x;
  const dz = game.input.mouse.worldZ - game.player.z;
  const len = Math.hypot(dx, dz);
  let x;
  let z;
  if (len > 1.25) {
    const inv = 1 / len;
    const d = Math.min(distance, len);
    x = game.player.x + dx * inv * d;
    z = game.player.z + dz * inv * d;
  } else {
    x = game.player.x + game.player.aimX * distance;
    z = game.player.z + game.player.aimZ * distance;
  }

  for (const wall of game.room.walls) {
    if (circleVsAabb(x, z, 0.8, wall.minX, wall.minZ, wall.maxX, wall.maxZ)) {
      return game.room.enemySpawns[0] || game.room.playerSpawn || { x: 0, z: -4 };
    }
  }
  return { x, z };
}

export function handleSandboxHotkeys(game) {
  if (game.runMode !== 'sandbox' || game.state !== 'playing' || !game.player?.alive) return;

  const spawn = debugSpawnPoint(game);
  if (game.input.consumeKey('Digit1')) {
    game._addEnemyByType('drone', spawn.x, spawn.z);
    game.toast('SPAWNED DRONE');
  }
  if (game.input.consumeKey('Digit2')) {
    game._addEnemyByType('enforcer', spawn.x, spawn.z);
    game.toast('SPAWNED ENFORCER');
  }
  if (game.input.consumeKey('Digit3')) {
    game._addEnemyByType('zealot', spawn.x, spawn.z);
    game.toast('SPAWNED ZEALOT');
  }
  if (game.input.consumeKey('Digit4')) {
    spawnBossPhase(game, 1, spawn.x, spawn.z);
  }
  if (game.input.consumeKey('Digit5')) {
    spawnBossPhase(game, 2, spawn.x, spawn.z);
  }
  if (game.input.consumeKey('Digit6')) {
    game._addEnemyByType('minmon', spawn.x, spawn.z);
    game.toast('SPAWNED MINMON');
  }
  if (game.input.consumeKey('Digit7')) {
    game._addEnemyByType('zilua', spawn.x, spawn.z);
    game.toast('SPAWNED ZILUA');
  }
  if (game.input.consumeKey('KeyG')) {
    game._setSandboxGodMode(!game._sandboxGodMode);
  }
  if (game.input.consumeKey('KeyR')) {
    game._clearEnemiesAndProjectiles();
    game.toast('CLEARED ALL ENEMIES');
    game.audio.playMusic('combat');
  }
  if (game.input.consumeKey('KeyH')) {
    game.player.heal(game.player.maxHp);
    game.toast('PLAYER FULLY HEALED');
  }
}


